/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React               from 'react';
import PropTypes           from 'prop-types';
import { ThemeProvider }   from 'styled-components';
import { Header }          from '../../organisms/Header';
import { Footer }          from '../../organisms/Footer';
import { Colours }         from '../../../styles/variables';
import { AvatarFlat }      from '../../atoms/AvatarFlat';
import { Logo }            from '../../molecules/Logo';
import { StyledContainer } from '../../atoms/StyledContainer'
import { StyledMain }      from '../../atoms/StyledMain';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const headerTheme = {
    LogoTextColor: Colours.White,
    TabletColor: Colours.White,
    TabletPosition: 'absolute',
    TabletBackground: 'transparent'
};

export const PictureHybridPage = ({ children }) => (
    <StyledContainer>
        <ThemeProvider theme={headerTheme}>
            <Header>
                <Logo>
                    <AvatarFlat/>
                </Logo>
            </Header>
        </ThemeProvider>
        <StyledMain>{children}</StyledMain>
        <Footer/>
    </StyledContainer>
);

PictureHybridPage.propTypes = {
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/templates/PictureHybridPage/index.js